import React, { useState } from 'react'

import { OrderContainer } from '~/components/elements/OrderContainer/OrderContainer'
import type { PrescriptionTimelineItem } from '~/types'

import type { OrderTableRow } from './components/OrderTable'
import { OrderTable } from './components/OrderTable'
import { LabelValueWrapper } from './LabelValueWrapper'
import { getPrescriptionFromRow } from './rxCardUtilities'
import RxOrderTableMenu from './RxOrderTableMenu'
import { useDispenseRefill } from './useDispenseRefill'
import { useRxCardContent } from './useRxCardContent'

import styles from './RxCardDetails.module.scss'

export interface RxCardDetailsProps {
  index?: number
  item: PrescriptionTimelineItem
}

export const RxCardDetails = ({ item, index }: RxCardDetailsProps) => {
  const { prescription } = item
  const [isOrderTableExpanded, setIsOrderTableExpanded] = useState(false)

  const handleDispenseRefill = useDispenseRefill(item)

  const rxContent = useRxCardContent(prescription, {
    itemDate: item.date,
    onDispenseRefill: handleDispenseRefill,
  })

  return (
    <>
      <div className={styles.container}>
        <div className={styles.fieldsGrid}>
          {rxContent.fields.map((field) => (
            <LabelValueWrapper
              boldValue={field.boldValue}
              key={field.label}
              label={field.label}
              tooltipText={field.tooltipText}
              value={field.value}
              onClick={field.onClick}
            />
          ))}
        </div>
        {rxContent.showTime && (
          <div className={styles.timeDisplay}>{rxContent.showTime}</div>
        )}
        {!rxContent.isCustomView && rxContent.instructions.value && (
          <>
            <div className={styles.divider} />
            <div className={styles.instructionsContainer}>
              <LabelValueWrapper
                label={rxContent.instructions.label}
                value={rxContent.instructions.value}
              />
            </div>
          </>
        )}
        {rxContent.orderTableData && !rxContent.isCustomView && (
          <div className={styles.orderContainerWrapper}>
            <OrderContainer
              expanded={isOrderTableExpanded}
              title={rxContent.orderTableTitle}
              onChange={(_event, expanded: boolean) =>
                setIsOrderTableExpanded(expanded)
              }
            >
              <OrderTable
                cardHeaders={rxContent.orderTableData.cardHeaders}
                headers={rxContent.orderTableData.headers}
                renderRowActions={(row: OrderTableRow[]) => (
                  <RxOrderTableMenu
                    index={index}
                    item={item}
                    refill={getPrescriptionFromRow(row, true)}
                  />
                )}
                rows={rxContent.orderTableData.rows}
                subHeader={rxContent.orderTableSubHeader}
              />
            </OrderContainer>
          </div>
        )}
      </div>
    </>
  )
}
